import Modal from './Modal';
import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';
import ModalAlert from './ModalAlert';

export { Modal, ModalHeader, ModalBody, ModalFooter, ModalAlert };



// WEBPACK FOOTER //
// ./src/ui/common/modal/index.js